import React from 'react';
import classNames from 'classnames';

import { makeStyles } from '@material-ui/core/styles';

import LogoImage from 'assets/logo-dark@2x.png';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    height: '100%'
  },
  image: {
    height: 'calc(100% - 4px)',
  }
});

const Logo = ({ className }) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, className)}>
      <img src={LogoImage} className={classes.image} alt="Logo" />
    </div>
  );
};

export default Logo;
